import { render } from "./ManagerPage.vue?vue&type=template&id=22c33a8a&scoped=true"
import script from "./ManagerPage.vue?vue&type=script&lang=js"
export * from "./ManagerPage.vue?vue&type=script&lang=js"

import "./ManagerPage.vue?vue&type=style&index=0&id=22c33a8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.2.2_@vue+compiler-sfc@3.3.4_vue@3.3.4_webpack@5.88.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22c33a8a"]])

export default __exports__